module.exports = __webpack_public_path__ + "img/5.c30efba0.jpg";